import React from 'react';
import _ from 'underscore';
import { compose } from 'recompose';
import { withCaptureFieldHandlers } from './Misc/forms';

class Image extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showTooltip: false };
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    handleMouseEnter() {
        if (this.props.tooltip) {
            this.setState({ showTooltip: true });
        }
    }

    handleMouseLeave() {
        this.setState({ showTooltip: false });
    }

    render() {
        const { showTooltip } = this.state;
        const { src, title, name, className, tooltip } = this.props;
        const classNames = ['image__action', _.isString(className) && className];

        // for backward compatibility and to prevent breaking all the other places,
        // the position: relative div is only added for the image with tooltip since they are introduced together
        return (
            <div className="image__container">
                <div className="image__wrapper image__wrapper--circle">
                    {!tooltip && (
                        <img src={src} alt={name} title={title} className={classNames.join(' ')} />
                    )}
                    {tooltip && (
                        <div
                            style={{
                                position: 'relative',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center',
                                padding: '10px',
                            }}>
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <img
                                    src={src}
                                    alt={name}
                                    title={title}
                                    className={classNames.join(' ')}
                                    onMouseEnter={this.handleMouseEnter}
                                    onMouseLeave={this.handleMouseLeave}
                                />
                                <div style={showTooltip ? visibleTooltipStyle : tooltipStyle}>
                                    {tooltip}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const tooltipStyle = {
    position: 'absolute',
    left: '50%',
    top: 0,
    transform: 'translate(-50%, -100%)',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: 'white',
    padding: '5px 10px',
    borderRadius: '4px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    zIndex: 1000,
    marginTop: '-5px',
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.3s ease, visibility 0.3s ease',
};

const visibleTooltipStyle = {
    ...tooltipStyle,
    opacity: 1,
    visibility: 'visible',
};

export default Image = compose(withCaptureFieldHandlers)(Image);
